import { render, staticRenderFns } from "./UserProfileContactPrefs.vue?vue&type=template&id=6612d3e4&scoped=true&"
import script from "./UserProfileContactPrefs.vue?vue&type=script&lang=js&"
export * from "./UserProfileContactPrefs.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileContactPrefs.vue?vue&type=style&index=0&id=6612d3e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6612d3e4",
  null
  
)

export default component.exports